import { useEffect, useState } from 'react'
import { getItemSessionStorage, getItemWebStorage } from '../../features/webStorageSaver'
import { useNavigate, useParams } from 'react-router-dom'
import { prepareTableData } from '../../features/dataFormatFunctions/dataFormatter'
import ContentHeader from '../../widgets/contentHeader/ContentHeader'
import { defineCustomTableColumns } from '../tables/custom/customTableObjectType/customTableObjectTypeFunctions'
import { defineTableFilters } from '../../widgets/table/tableFeatures/tableFunctions'
import { useAppSelector } from '../../stateManagement/hooks/redux'
import TableWidget from '../../widgets/table/tableWidget/TableWidget'

export default function CustomObjectsOnMapInfo() {
    const navigate = useNavigate()
    const { id, objectType }: any = useParams()
    const [name, setName] = useState<any>(null)
    const [columns, setColumns] = useState<any>(null)
    const [tableData, setTableData] = useState<any>([])
    const [tableState, setTableState] = useState<any>(null)
    const [isErrorTableStructure, setIsErrorTableStructure] = useState<boolean>(false)
    const restAuthToken = useAppSelector(state => state.customAuth.customAuthToken)
    const currentConfig = getItemWebStorage('currentConfig')
    const { mapAdditionalItems, cardAdditionalItems } = currentConfig
    const cardAdditionalItem = cardAdditionalItems.find((item: any) => item?.id === id)
    const mapAdditionalItem = mapAdditionalItems.find((item: any) => item?.id === id)

    useEffect(() => {
        configureName()
    }, [])

    useEffect(() => {
        if (columns) {
            configureData()
        }
    }, [columns])

    function configureName() {
        const { objectsList } = mapAdditionalItem ?? {}
        const { title } = objectsList ?? {}
        if (title) {
            setName(title)
        }
    }

    function configureData() {
        const { objectsList } = mapAdditionalItem ?? {}
        let { order, field } = objectsList?.structure?.sort ?? {}
        let data: any = []
        const features = getItemSessionStorage('customMap.features') ?? []
        features.map((feature: any) => {
            let geoEntityId = feature.id?.split('.')[1]
            let dataObject = {
                ...feature?.properties,
                geoEntityId
            }
            data.push(dataObject)
        })
        if (field && order) {
            data.sort((a: any, b: any) => order === 'asc' ? a[field].localeCompare(b[field]) : b[field].localeCompare(a[field]));
        }
        setTableData(prepareTableData(data, columns))
    }

    function onRowSelect(event: any) {
        let { url: cardUrl } = cardAdditionalItem ?? {}
        let { getFeatureInfoOptions } = mapAdditionalItem ?? {}
        const propertyForEntityId = getFeatureInfoOptions?.propertyForEntityId
        let entityId = propertyForEntityId ? event?.data?.[propertyForEntityId] : event?.data?.geoEntityId
        if (cardUrl) {
            cardUrl = cardUrl.replace(':id', `${id}`)
            cardUrl = cardUrl.replace(':objectType', `${objectType}`)
            cardUrl = cardUrl.replace(':entityId', `${entityId}`)
            navigate(`/app/${cardUrl}`)
        }
    }

    async function defineTableColumns() {
        const { objectsList, openDataOptions: restAuthRequestOptions, api } = mapAdditionalItem ?? {}
        const { structure } = objectsList ?? {}
        if (structure) {
            let columnsStructure: any = structure?.columns
            let columns = await defineCustomTableColumns(columnsStructure, api, restAuthToken, restAuthRequestOptions)
            if (columns) {
                setColumns(columns)
            }
            let filters = defineTableFilters(columns)
            if (filters) {
                setTableState({ filters })
            }
        } else {
            setIsErrorTableStructure(true)
        }
    }

    useEffect(() => {
        if (restAuthToken) {
            defineTableColumns()
        }
    }, [restAuthToken])

    return (
        <>
            <ContentHeader title={name} />
            <div className="table-widget-with-toast with-content-header">
                <TableWidget
                    tableValue={tableData}
                    tableState={tableState}
                    columns={columns}
                    onRowSelect={onRowSelect}
                    type='custom'
                    canBeFiltered={false}
                />
            </div>
        </>
    )
}
